import { InventoryAdjustmentStatus, InventoryAdjustmentType } from "@/graphql/codegen/graphql"

export enum AdjustmentHistoryActionType {
  DocumentsView = "DOCUMENTS_VIEW",
  WorkOrderPrint = "WORK_ORDER_PRINT",
}

export enum AdjustmentWorkOrderPalletRole {
  Source = "SOURCE",
  Target = "TARGET",
  New = "NEW",
}

export const ADJUSTMENT_STATUS_TO_LABEL: Record<InventoryAdjustmentStatus, string> = {
  [InventoryAdjustmentStatus.Pending]: "Pending",
  [InventoryAdjustmentStatus.WorkOrderPending]: "Work Order Pending",
  [InventoryAdjustmentStatus.PendingSync]: "Pending Sync to AS400",
  [InventoryAdjustmentStatus.Completed]: "Completed",
  [InventoryAdjustmentStatus.PartiallyFailed]: "Partially Failed",
  [InventoryAdjustmentStatus.Failed]: "Failed",
} as const

export const ADJUSTMENT_TYPE_TO_CHIP_CLASS: Record<InventoryAdjustmentType, string> = {
  [InventoryAdjustmentType.AdjustQuantity]: "bg-primary-200",
  [InventoryAdjustmentType.SplitPallets]: "bg-tertiary-purple-300",
  [InventoryAdjustmentType.CombinePallets]: "bg-tertiary-pink-300",
  [InventoryAdjustmentType.LotBatchCorrection]: "bg-gray-300",
  [InventoryAdjustmentType.AddNewPallets]: "bg-tertiary-green-100",
  [InventoryAdjustmentType.As400Adjustment]: "bg-tertiary-yellow-300",
} as const

export const ADJUSTMENT_STATUS_TO_CHIP_CLASS: Record<InventoryAdjustmentStatus, string> = {
  [InventoryAdjustmentStatus.Pending]: "bg-tertiary-yellow-300",
  [InventoryAdjustmentStatus.WorkOrderPending]: "bg-tertiary-yellow-300",
  [InventoryAdjustmentStatus.PendingSync]: "bg-tertiary-yellow-300",
  [InventoryAdjustmentStatus.Completed]: "bg-tertiary-green-100",
  [InventoryAdjustmentStatus.PartiallyFailed]: "bg-secondary-200",
  [InventoryAdjustmentStatus.Failed]: "bg-secondary-200",
} as const

export const PALLET_LABEL_PRINTABLE_STATUSES: InventoryAdjustmentStatus[] = [
  InventoryAdjustmentStatus.Completed,
  InventoryAdjustmentStatus.PartiallyFailed,
  InventoryAdjustmentStatus.WorkOrderPending,
]

export const ADJUSTMENT_TYPES_WITH_WORK_ORDERS: InventoryAdjustmentType[] = [
  InventoryAdjustmentType.SplitPallets,
  InventoryAdjustmentType.CombinePallets,
  InventoryAdjustmentType.AddNewPallets,
]
